import makeStyles from '@mui/styles/makeStyles';

const useGlobalStyles = makeStyles((theme) => ({
    flexDisplay: {
      display: 'flex',
    },
    flexCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    flexColumn: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    justifyContentBetween: {
      justifyContent: 'space-between',
    },
    alignItemsCenter: {
      alignItems: 'center',
    },
  }));
  
  export default useGlobalStyles;
